import React from 'react'
import { Link } from 'react-router-dom'
import { useAuthStore } from '../../../store/authStore'

const products = [
  { id: 'pvc', name: 'Tarjeta PVC NFC', desc: 'Serigrafiado, resistente y profesional' },
  { id: 'bamboo', name: 'Tarjeta Bamboo NFC', desc: 'Sostenible y elegante' },
  { id: 'keychain', name: 'Llavero NFC', desc: 'Acceso rápido en todo momento' },
  { id: 'sticker', name: 'Sticker NFC', desc: 'Adhesivo para cualquier superficie' },
]

const imageCandidates = {
  pvc: ['/nfc/pvcolores.png', '/nfc/plateado.png', '/nfc/negromate.png', '/pvc-nfc.svg', '/portada.png'],
  bamboo: ['/nfc/bambu.png', '/bamboo-nfc.svg', '/portada.png'],
  keychain: ['/nfc/llaveroredondo.png', '/nfc/llaveroredondotransparente.png', '/nfc/llaveronegro.png', '/keychain-nfc.svg', '/portada.png'],
  sticker: ['/nfc/colores.png', '/nfc/blanco.png', '/sticker-nfc.svg', '/portada.png'],
}

function nextFallback(e, id) {
  const list = imageCandidates[id] || ['/portada.png']
  const idx = Number(e.currentTarget.dataset.fallbackIndex || 0)
  const nextIdx = idx + 1
  if (nextIdx < list.length) {
    e.currentTarget.dataset.fallbackIndex = String(nextIdx)
    e.currentTarget.src = list[nextIdx]
  }
}

function NFCPage() {
  const { user } = useAuthStore()

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-extrabold text-gray-900">Tarjetas y Accesorios NFC</h1>
          <p className="mt-3 text-gray-600">Personalizados y enlazados a tu Dkard</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map(p => (
            <div key={p.id} className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col">
              <div className="h-48 w-full">
                <img
                  src={imageCandidates[p.id][0]}
                  alt={p.name}
                  className="w-full h-full object-cover"
                  data-fallback-index="0"
                  onError={(e) => nextFallback(e, p.id)}
                />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="text-lg font-semibold text-gray-900">{p.name}</h3>
                <p className="mt-1 text-sm text-gray-600">{p.desc}</p>
                <div className="mt-auto flex gap-3 pt-4">
                  <Link to={`/templates?template=${p.id === 'sticker' || p.id === 'keychain' ? 'template-3' : 'template-4'}`} className="text-primary-600 hover:text-primary-700 text-sm font-medium">Ver modelos →</Link>
                  <Link to={user ? '/editor' : '/auth/login'} className="btn-primary text-sm">Vincular a mi Dkard</Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link to="/templates" className="btn-secondary">Ver todas las plantillas</Link>
        </div>

        <div className="mt-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Modelos</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { id: 'pvcolores', name: 'Tarjeta PVC Colores', image: '/nfc/pvcolores.png', tags: ['PVC','Colores','Serigrafía'] },
              { id: 'plateado', name: 'Tarjeta PVC Plateado', image: '/nfc/plateado.png', tags: ['PVC','Plateado','Brillo'] },
              { id: 'negromate', name: 'Tarjeta PVC Negro Mate', image: '/nfc/negromate.png', tags: ['PVC','Negro','Mate'] },
              { id: 'bambu', name: 'Tarjeta Bamboo', image: '/nfc/bambu.png', tags: ['Bamboo','Sostenible','Grabado'] },
              { id: 'llaveroredondo', name: 'Llavero NFC Redondo', image: '/nfc/llaveroredondo.png', tags: ['Llavero','Redondo'] },
              { id: 'llaverotransparente', name: 'Llavero NFC Transparente', image: '/nfc/llaveroredondotransparente.png', tags: ['Llavero','Transparente'] },
              { id: 'llaveronegro', name: 'Llavero NFC Negro', image: '/nfc/llaveronegro.png', tags: ['Llavero','Negro'] },
              { id: 'stickercolores', name: 'Sticker NFC Colores', image: '/nfc/colores.png', tags: ['Sticker','Colores'] },
              { id: 'stickerblanco', name: 'Sticker NFC Blanco', image: '/nfc/blanco.png', tags: ['Sticker','Blanco'] },
            ].map(m => (
              <div key={m.id} className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden">
                <div className="h-56 w-full">
                  <img
                    src={m.image}
                    alt={m.name}
                    className="w-full h-full object-cover"
                    onError={(e) => { e.currentTarget.src = '/portada.png' }}
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-900">{m.name}</h3>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {m.tags.map(t => (
                      <span key={t} className="px-3 py-1 bg-primary-50 text-primary-700 border border-primary-100 rounded-full text-xs">{t}</span>
                    ))}
                  </div>
                  <div className="mt-4 flex gap-3">
                    <Link to={`/templates?template=${m.tags.includes('Sticker') ? 'template-3' : 'template-4'}`} className="text-primary-600 hover:text-primary-700 text-sm font-medium">Ver más →</Link>
                    <Link to={user ? '/editor' : '/auth/login'} className="btn-primary text-sm">Vincular a mi Dkard</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NFCPage
